import React from 'react';
import {Link} from 'react-router-dom';

function Footer(){
  return (
    <div>
      <div className="row justify-content-center align-items-center mt-4">
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
              <Link to="/">Home</Link>
              &nbsp;•&nbsp;
              <a target="_blank" href="/kb/tos">Terms of Service</a>
              &nbsp;•&nbsp;
              <a target="_blank" href="/kb/privacy">Privacy</a>
              &nbsp;•&nbsp;
              <a target="_blank" href='mailto:support@fullstack.cafe'>Contacts</a>
            </span>
          </span>
        </div>
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
              <a target="_blank" href="/kb/wordpress">Wordpress</a>
              &nbsp;•&nbsp;
              <a target="_blank" href="/kb/shopify">Shopify</a>
              &nbsp;•&nbsp;
              <a target="_blank" href="/kb/excel">Excel</a>
              &nbsp;•&nbsp;
              <a target="_blank" href="/kb/joomla">Joomla</a>
              &nbsp;•&nbsp;
              <a target="_blank" href="/kb/drupal">Drupal</a>
            </span>
          </span>
        </div>
      </div>
      <div className="row justify-content-center align-items-center">
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
            GoldAPI is a Free Gold Prices API and Silver Prices RESTful JSON API. 100% Real-Time Live Feed of Precious Metals Spot Prices.
            </span>
          </span>
        </div>
      </div>
      <div className="row justify-content-center align-items-center mb-5">
        <div className="col-12 text-center justify-content-center align-items-center">
          <span className="small text-muted">
            <span className="small">
              © 2020-2025, GoldAPI.io
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;